import axios from 'axios';
import qs from 'qs';

import { toHttpError } from '@bonusly/http';
import { getToken } from '@bonusly/who-am-i';

type CreateHttpClientOptions = {
	onUnauthorized?: () => void;
};

export const createHttpClient = (baseURL: string, options: CreateHttpClientOptions = {}) => {
	const client = axios.create({
		baseURL,
		headers: {
			'X-BONUSLY-SOURCE': 'internal',
		},
		xsrfCookieName: 'X-CSRF-TOKEN',
		xsrfHeaderName: 'X-CSRF-TOKEN',
		withCredentials: true,
	});

	client.defaults.paramsSerializer = (params) => {
		return qs.stringify(params, { arrayFormat: 'brackets' });
	};

	client.interceptors.request.use(async (config) => {
		const token = await getToken();

		if (token && config.headers) {
			config.headers.Authorization = `Bearer ${token}`;
		}

		return config;
	});

	client.interceptors.response.use(
		(response) => response,
		(error) => {
			if (toHttpError(error).isUnauthorized) {
				options.onUnauthorized?.();
			}

			return Promise.reject(error);
		}
	);

	return client;
};
